import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: theme.size.base,
    cursor: 'default'
  }
}))

export default useStyles
